module.exports = __webpack_public_path__ + "static/young-leader-photo-genevieve_rogers-414a2621dabfbf737caf5d3faedf04ef.jpg";